var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M21.534 12.187c0-.82-.067-1.417-.21-2.037h-9.357v3.698h5.492c-.11.919-.709 2.303-2.037 3.233l-.02.124 2.96 2.292.204.02c1.883-1.738 2.968-4.296 2.968-7.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M11.967 21.931c2.69 0 4.95-.886 6.6-2.414l-3.145-2.436c-.842.587-1.971.997-3.455.997-2.635 0-4.872-1.738-5.67-4.141l-.116.01-3.076 2.38-.04.112c1.638 3.256 5.004 5.492 8.902 5.492z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M6.298 13.937c-.21-.62-.332-1.285-.332-1.971 0-.687.122-1.351.321-1.971l-.005-.132-3.115-2.42-.102.05c-.675 1.35-1.063 2.867-1.063 4.473 0 1.605.388 3.122 1.063 4.473l3.233-2.502z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB4335",
    d: "M11.967 5.853c1.871 0 3.134.809 3.853 1.484l2.813-2.746C16.906 2.986 14.658 2 11.967 2 8.07 2 4.703 4.237 3.064 7.492l3.223 2.503c.808-2.403 3.045-4.142 5.68-4.142z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H19.544V20H0z",
    transform: "translate(2 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon-google.5d0d36169f27692b7626ba610c74e5f4.svg";
export { ForwardRef as ReactComponent };